import { Link } from "react-router-dom";
import { Phone } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-[#E5DEC9] bg-[#FFFFFF]">
      <div className="mx-auto grid max-w-7xl gap-12 px-6 py-16 sm:px-12 md:grid-cols-3 lg:px-20">
        <div>
          <img
            src="/images/logo-patch.png"
            alt="Bespoke Maestro label"
            className="mb-5 h-24 w-auto rounded-sm"
            data-testid="footer-logo"
          />
          <p className="font-serif text-2xl font-semibold text-[#1A1917]">Bespoke Maestro</p>
          <p className="mt-3 max-w-xs text-sm font-light leading-relaxed text-[#524F4A]">
            Bespoke &amp; made-to-measure tailoring for men and women. By appointment only —
            San Diego &amp; Orange County, since 2018.
          </p>
        </div>
        <div>
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#858078]">Atelier</p>
          <ul className="mt-4 space-y-2 text-sm font-light text-[#524F4A]">
            <li>Private consultations at your home, office, hotel or our studio</li>
            <li>La Jolla · Del Mar · Coronado · Carmel Valley · Downtown San Diego</li>
            <li className="flex items-center gap-2 pt-2 text-[#1A1917]">
              <Phone size={14} />
              <a href="tel:+18582694468" data-testid="footer-phone-link" className="hover:text-[#8C6D38]">
                (858) 269-4468
              </a>
            </li>
          </ul>
        </div>
        <div>
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#858078]">Begin</p>
          <Link
            to="/book"
            data-testid="footer-book-button"
            className="mt-4 inline-block border border-[#1A1917] px-6 py-3 font-mono text-[11px] uppercase tracking-[0.25em] text-[#1A1917] transition-colors duration-200 hover:bg-[#1A1917] hover:text-[#FFFFFF] active:scale-95"
          >
            Book a Fitting
          </Link>
          <p className="mt-6">
            <Link
              to="/admin/login"
              data-testid="footer-admin-link"
              className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#858078] hover:text-[#1A1917]"
            >
              Atelier Login
            </Link>
          </p>
        </div>
      </div>
      <div className="border-t border-[#E5DEC9] py-6 text-center font-mono text-[10px] uppercase tracking-[0.3em] text-[#858078]">
        © {new Date().getFullYear()} Bespoke Maestro · San Diego, California
      </div>
    </footer>
  );
}
